// @ts-nocheck
import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {adapterContactSimple} from "../../adapters/contact.adapter";
import {listMyContactsService} from "../../services/contacts/contact.service";
import useContactStore from "../../store/Contacts/useContact.store";

const useListContacts = () => {
  const [contacts, setContacts] = useState([]);
  const setMyContacts = useContactStore(state => state.setMyContacts);
  const filterContacts = useContactStore(state => state.filterContacts);
  const [faves, setFaves] = useState([]);
  const {data, isSuccess, isLoading, isError, error} = useQuery({
    queryKey: ["listContacts"],
    queryFn: listMyContactsService,
    staleTime: 300,
  });

  const mapperContacts = payload => {
    const mapped = payload
      .map(item => {
        return adapterContactSimple(item);
      })
      .sort((a, b) => a.name.localeCompare(b.name))
      .sort((a, b) => b.isFavorite - a.isFavorite);
    return mapped;
  };

  const mapperFaves = payload => {
    const listFaves = payload
      .filter(item => item?.is_favorite)
      .map(item => {
        return adapterContactSimple(item);
      });
    return listFaves;
  };

  useEffect(() => {
    if (data?.data?.data) {
      const myContacts = mapperContacts(data?.data?.data);
      const myFaves = mapperFaves(data?.data?.data);
      setContacts(myContacts);
      setMyContacts(myContacts);
      filterContacts("");
      setFaves(myFaves);
    }
  }, [isSuccess, data?.data]);

  return {contacts, faves, isSuccess, isError, error, isLoading};
};

export default useListContacts;
